import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { openOpsStream, openCustomerStream, type StreamStatus } from "./stream";
import type { IEvent } from "./proto";

export function useCustomerStream(): StreamStatus {
  const qc = useQueryClient();
  const [status, setStatus] = useState<StreamStatus>("connecting");

  useEffect(() => {
    const handle = openCustomerStream(
      (ev: IEvent) => {
        if (ev.kind === "state") {
          void qc.invalidateQueries({ queryKey: ["parcels"] });
          if (ev.parcelId) void qc.invalidateQueries({ queryKey: ["parcel", ev.parcelId] });
        } else if (ev.kind === "ticket_message") {
          void qc.invalidateQueries({ queryKey: ["my-unread"] });
          void qc.invalidateQueries({ queryKey: ["my-tickets"] });
          if (ev.parcelId) void qc.invalidateQueries({ queryKey: ["conversation", ev.parcelId] });
        }
      },
      { onStatus: setStatus },
    );
    return () => handle.close();
  }, [qc]);

  return status;
}

export function useOpsStream(): StreamStatus {
  const qc = useQueryClient();
  const [status, setStatus] = useState<StreamStatus>("connecting");

  useEffect(() => {
    const handle = openOpsStream(
      (ev: IEvent) => {
        if (ev.kind === "state") {
          void qc.invalidateQueries({ queryKey: ["ops", "parcels"] });
          void qc.invalidateQueries({ queryKey: ["ops", "dashboard"] });
          if (ev.parcelId) void qc.invalidateQueries({ queryKey: ["parcel", ev.parcelId] });
        } else if (ev.kind === "ticket_message") {
          void qc.invalidateQueries({ queryKey: ["ops", "conversations"] });
          void qc.invalidateQueries({ queryKey: ["ops", "unread"] });
          if (ev.parcelId) void qc.invalidateQueries({ queryKey: ["conversation", ev.parcelId] });
        } else if (ev.kind === "payment") {
          void qc.invalidateQueries({ queryKey: ["ops", "transactions"] });
        }
      },
      { onStatus: setStatus },
    );
    return () => handle.close();
  }, [qc]);

  return status;
}
